module.exports = __webpack_public_path__ + "media/about/history-ac15a86c.jpg";